import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/voucher";
const API_PATH_2 = ConstantList.API_EN_POINT + "/voucher-item";
const API_PATH_EXPORT_SERVICE =
  ConstantList.API_EN_POINT + "/patient-service-register";
const API_PATH_EXPORT_CARD = ConstantList.API_EN_POINT + "/treatment-plan-card";
const API_PATH_EXPORT_DRUG = ConstantList.API_EN_POINT + "/drug";
const API_PATH_ELASTIC = ConstantList.API_EN_POINT + "/";
// Helper function to add payment method limit flag
const addPaymentMethodLimit = (voucherData) => {
  const limitMethods = ConstantList.PAYMENT_METHOD_LIMITS;
  if (Array.isArray(limitMethods) && limitMethods.length > 0) {
    return {
      ...voucherData,
      limitPaymentMethodCodes: limitMethods
    };
  }
  return voucherData;
};

export const  onOffLimitPage= (dto) =>
  axios.post(API_PATH + "/update-show-on-limit-page", dto);

export const cancelVoucherReason = (obj) =>
  axios.delete(API_PATH + "/cancel-voucher-with-reason", {
    data: obj,
  });

export const printApi = (voucherId) =>
  axios.get(`${API_PATH}/get-print-voucher-group-treatment/${voucherId}`);

export const createCollectFeeVoucher = (dto) =>
  axios.post(API_PATH + "/create-voucher-by-invoice/1", dto);

export const createVoucherByInvoice = (object) =>
  axios.post(API_PATH + "/print-invoice", object);

export const printVoucherByInvoiceId = (invoiceId) =>
  axios.get(API_PATH + "/print-invoice/" + invoiceId);

export const printInvoiceDto = (invoice) =>
  axios.post(API_PATH + "/print-invoice-dto", invoice);

export const pagingVoucher = (voucher) =>
  axios.post(API_PATH + "/search-by-page", voucher);

export const getVoucherById = (voucherId) =>
  axios.get(API_PATH + "/get-by-id/" + voucherId);

export const getVoucherCancelById = (voucherId) =>
  axios.get(API_PATH + "/get-cancel-by-id/" + voucherId);

export const getInvoiceUnPaidByPatientId = (patientId) =>
  axios.get(API_PATH + "/get-invoice-un-paid/" + patientId);

export const createVoucherByListInvoice = (dto) =>
  axios.post(API_PATH + "/create-voucher-by-list-invoice", dto);

export const getVoucherByInvoiceId = (invoiceId) =>
  axios.get(API_PATH + "/get-voucher-by-invoice/" + invoiceId);
export const saveVoucher = (dto) => axios.post(API_PATH + "/save", dto);
export const settlementOfHospitalFees = (dto) =>
  axios.post(API_PATH + "/settlement-of-hospital-fees", dto);
export const saveOrUpdateInvoiceAccounting = (dto) =>
  axios.post(API_PATH + "/save-invoice-accounting", dto);
export const sendStoreRequestByVisit = (dto) =>
  axios.post(API_PATH + "/send-store-request-by-visit", dto);
export const getInvoiceAccountingByVoucherId = (voucherId) =>
  axios.get(API_PATH + `/get-invoice-accounting-by-voucher-id/${voucherId}`);
//huy hoa don
export const deleteByVoucherId = (voucherId) =>
  axios.delete(API_PATH + `/delete-by-id/${voucherId}`);
//duyet phoi
export const saveMedicalExpensesReviewer = (dto) =>
  axios.post(API_PATH + "/save-medical-expenses-reviewer", dto);
//go duyet phoi
export const openMedicalExpenses = (dto) =>
  axios.post(API_PATH + "/open-medical-expenses", dto);

export const getInvoiceByNeedToPay = (dto) =>
  axios.post(API_PATH + "/get-invoice-need-to-pay", dto);

export const reCalculateWithVoucher = (dto) =>
  axios.post(API_PATH + "/re-caculate-with-voucher", dto);

export const getInvoiceByNeedToPayByGroup = (dto) =>
  axios.post(API_PATH + "/get-invoice-need-to-pay-by-group", dto);

export const createVoucherByListInvoiceItem = (dto) =>
  axios.post(API_PATH + "/create-voucher-by-list-invoice-item", dto);
// hoàn trả dv
export const createRefundByListInvoiceItem = (dto) =>
  axios.post(API_PATH + "/refund-by-list-invoice-item", dto);
// quyết toán
export const createVoucherDischarge = (dto) =>
  axios.post(API_PATH + "/settlement-by-list-invoice-item", dto);
// hoàn tiền
export const getInvoiceByNeedToRefundByGroup = (dto) =>
  axios.post(API_PATH + "/get-invoice-need-to-refund-by-group", dto);

export const createRefundVoucherByListInvoiceItem = (dto) =>
  axios.post(API_PATH + "/create-refund-voucher-by-list-invoice-item", dto);
// lại tính tiền
export const rePaymentByListInvoiceItem = (dto) =>
  axios.post(API_PATH + "/re-payment-by-list-invoice-item", dto);

//huy voucher
export const cancelVoucherById = (voucherId) =>
  axios.get(API_PATH + `/cancel-by-id/${voucherId}`);
// thu công nợ
export const createDebtVoucher = (voucher) =>
  axios.post(API_PATH + `/create-debt-voucher`, voucher);
export const getListVoucherByInvoice = (obj) =>
  axios.post(API_PATH + "/get-list-voucher-by-invoice", obj);

//phieu tạm ứng
export const createAdvanceVoucher = (voucher) =>
  axios.post(API_PATH + `/create-advance-voucher`, voucher);

//lay phieu ds voucher tam ung
export const getAdvanceVoucher = (voucher) =>
  axios.post(API_PATH + `/get-list-voucher-advance`, voucher);

//update  voucher tam ung
export const updateAdvanceVoucher = (voucher) =>
  axios.post(API_PATH + `/update-status-advance-voucher`, voucher);

//delete  voucher tam ung
export const deleteAdvanceVoucher = (id) =>
  axios.delete(API_PATH + `/delete-new-voucher-by-id/${id}`);

export const getListAdvanceVoucherGroupByPatient = (voucher) =>
  axios.post(API_PATH + "/get-list-advance-voucher-group-by-patient", voucher);

// phieu thu
export const createReceiptInvoince = (voucher) =>
  axios.post(API_PATH + `/create-voucher-receive`, voucher);

// phieu chi
export const createPayInvoince = (voucher) =>
  axios.post(API_PATH + `/create-voucher-pay`, voucher);

//xoa phieu
export const deleteByVoucherMarkId = (voucherId) =>
  axios.delete(API_PATH + `/mark-delete/${voucherId}`);

export const exportVoucherXml = (obj) => {
  let url = API_PATH + "/export-voucher-xml";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const exportListVoucherXml = (obj) => {
  let url = API_PATH + "/export-list-voucher-xml";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const pageVoucherTotalCategory = (voucher) =>
  axios.post(API_PATH + "/paging-voucher-total-category", addPaymentMethodLimit(voucher));

export const createVoucherAndUpdateToCrm = (voucher) =>
  axios.post(API_PATH + "/create-voucher-and-update-to-crm", voucher);

export const getDetailById = (voucherId) =>
  axios.get(API_PATH + "/get-detail/" + voucherId);

export const updateVoucher = (obj) =>
  axios.post(API_PATH + "/update-voucher-after-payment", obj);

export const receiveAdvancePayment = (obj) =>
  axios.post(API_PATH + "/receive-advance-payment", obj);

export const cancelVoucherAndUpdateInvoice = (voucherId) =>
  axios.delete(API_PATH + `/cancel-voucher-and-update-invoice/${voucherId}`);

export const createPaymentVoucherWithListMethod = (obj) =>
  axios.post(API_PATH + `/create-payment-voucher-with-list-method`, obj);

export const createReceiveVoucherWithListMethod = (obj) =>
  axios.post(API_PATH + `/create-receive-voucher-with-list-method`, obj);

export const exportVoucherReport = (obj) => {
  let url = API_PATH + "/export-excel-report-by-payment-method";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const exportVoucherReportExpense = (obj) => {
  let url = API_PATH + "/export-excel-report-expense";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const exportReportServiceItem = (obj) => {
  let url = API_PATH_EXPORT_SERVICE + "/export-excel-psr-list";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const exportReportDrugItem = (obj) => {
  let url = API_PATH_EXPORT_DRUG + "/export-excel-drug-order-list";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const exportReportCardItem = (obj) => {
  let url = API_PATH_EXPORT_CARD + "/export-excel-tpc-list";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
};

export const createTemporaryVoucher = (obj) =>
  axios.post(API_PATH + `/create-temporary-voucher`, obj);

export const updateVoucherTemporary = (obj) =>
  axios.post(API_PATH + "/update-voucher-temporary", obj);
export const cancelTransactionOfMethod = (obj) =>
  axios.post(API_PATH + "/cancel-transaction-of-method", obj);

export const pagingVoucherSync = (obj) =>
  axios.post(API_PATH_2 + "/paging-voucher-item-sync", obj);

export const pagingVoucherHistory = (obj) => {
  return axios.post(API_PATH_ELASTIC + "elastic-voucher/search", obj);
};

export const updateTotalBillStatusInvoiceItem = (invoiceItemId) =>
  axios.get(
    API_PATH + `/update-total-bill-status-invoice-item/${invoiceItemId}`
  );

// lấy ra list phiếu cọc tiền
export const getRefundableDepositItems = (patientId) =>
  axios.get(API_PATH + `/get-refundable-deposit-items/${patientId}`);

// tạo phiếu hoàn tiền
export const createRefundDepositVoucher = (dto) =>
  axios.post(API_PATH + "/create-refund-deposit-voucher", dto);

